import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import InputField from '@commonComponents/formComponents/CustomInputField'
import PopUpIcon from '@commonComponents/formComponents/PopUpIcon'

export const MerchForm4 = React.memo(
  ({
    dataSource: {
      id: merchandiseId,
      invoiceId,
      unitOfMeasurement,
      grossMass,
      netMass,
      itemPrice,
      convertedValue,
      statisticalValue,
      customValue,
      valuationMethod,
      natureOfTransaction,
      quotaNumber,
      upu = '',
      eccn = '',
      commodityCode
    },
    isDMS,
    onSelect,
    onBlur,
    uomList,
    currency,
    exchangeRate,
    onChange,
    disableFields = false,
    renderAtLast,
    translate,
    validateLineItem,
    disabled,
    isDisabled,
    isImportShipment,
    isMerchandiseDisabled
  }) => {
    const onChangeHandler = useCallback(
      ({ target: { value, name } }) => onChange(value, name),
      [merchandiseId, onChange]
    )
    const onDropDownChange = useCallback(
      (e, { value, name }) => onSelect(value, name),
      [merchandiseId, onSelect]
    )
    const onBlurHandler = useCallback(
      ({ target: { value, name } }) => {
        if (validateLineItem) validateLineItem(name, value)
        onBlur(value, name)

      },
      [merchandiseId, onBlur]
    )
    return (
      <>
        <Grid.Column>
          <DropDown
            id={`uom-${invoiceId}-${merchandiseId}`}
            type='text'
            label="UOM"
            value={unitOfMeasurement}
            text={unitOfMeasurement}
            data={uomList}
            clearable
            name='unitOfMeasurement'
            onChange={onDropDownChange}
            isDisabled={isMerchandiseDisabled}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            isLabel={false}
            id={`grossMass-${invoiceId}-${merchandiseId}`}
            type='text'
            label="GROSS_MASS"
            isDisabled={isMerchandiseDisabled || disabled || null}
            value={grossMass}
            name='grossMass'
            boxNumber='6/4'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            isLabel={false}
            id={`netMass-${invoiceId}-${merchandiseId}`}
            type='text'
            label='NET_MASS_DMS'
            isDisabled={isMerchandiseDisabled || disabled || null}
            boxNumber='6/4'
            value={netMass}
            name='netMass'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            isLabel={false}
            id={`itemAmount-${invoiceId}-${merchandiseId}`}
            type='text'
            label="ITEM_AMOUNT"
            boxNumber='4/14'
            labelIcon={
              !currency && (
                <PopUpIcon
                  icon='info circle'
                  position='top left'
                  popupText={translate("ITEM_AMOUNT_POPUP_TEXT")}
                />
              )
            }
            value={itemPrice}
            name='itemPrice'
            isDisabled={isMerchandiseDisabled || isDisabled || !currency || null}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            isLabel={false}
            id={`exchangeRate-${invoiceId}-${merchandiseId}`}
            type='text'
            label="EXCHANGE_RATE"
            value={exchangeRate}
            name='exchangeRate'
            isDisabled={true}
            boxNumber='4/15'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            isLabel={false}
            id={`eurValue-${invoiceId}-${merchandiseId}`}
            type='text'
            label="EUR_VALUE"
            value={convertedValue}
            isDisabled={true}
            name='convertedValue'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        {(isDMS && isImportShipment) && (
          <Grid.Column>
            <InputField
              isLabel={false}
              id={`customValue-${invoiceId}-${merchandiseId}`}
              type='text'
              label='CUST_VALUE'
              value={customValue}
              name='customValue'
              onChange={onChangeHandler}
              onBlur={onBlurHandler}
              isDisabled={isMerchandiseDisabled || isDisabled || isDMS || null}
            />
          </Grid.Column>
        )}
        <Grid.Column>
          <InputField
            isLabel={false}
            id={`statisticalValue-${invoiceId}-${merchandiseId}`}
            type='text'
            label="STAT_VALUE"
            boxNumber='8/6'
            value={statisticalValue}
            name='statisticalValue'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
            isDisabled={isMerchandiseDisabled || isDisabled || isDMS || null}
          />
        </Grid.Column>
        {renderAtLast &&
          renderAtLast({
            disableFields,
            customValue,
            valuationMethod,
            quotaNumber,
            natureOfTransaction,
            upu,
            eccn,
            commodityCode,
            onChangeHandler,
            onBlurHandler,
            onDropDownChange,
            translate,
            isMerchandiseDisabled
          })}
      </>
    )
  }
)

MerchForm4.defaultProps = {
  translate: (value) => value,
}
